import {getUserUid} from '@/services/helpers';

class StepperFlow {
  public radius = 5;
  public location: any = {};
  public keywords: string [] = this.getDefaultKeywords();

  public saveLocationState() {



    const location = {
      formattedLocation: this.location.formattedLocation,
      lat: this.location.latitude,
      long: this.location.longitude,
    };

    this.saveUserData({location, radius: this.radius});
  }

  public saveKeywords() {
    this.saveUserData({keywords: this.keywords});
  }

  public saveIsLoan(isLoan: boolean) {
    return this.saveUserData({isLoan});
  }

  public saveIsCvd(isCvd: boolean) {
    return this.saveUserData({isCvd});
  }

  private saveUserData(updateParams: object) {
    const uid = getUserUid();

    if (uid) {
      return fetch(`${process.env.VUE_APP_API_ENDPOINT}/update-web-push-user`, {
        method: 'POST',
        body: JSON.stringify({uid, updateParams}),
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }

    return Promise.reject('Missing uid param');
  }

  private getDefaultKeywords() {
    const searchParams = new URLSearchParams(window.location.search);

    /*if (searchParams.has('q')) {
      var qArr = [searchParams.get('q')] as string[];
      qArr[0] = qArr[0].replace("+", " ");
      return qArr;
    }*/

    return [];
  }
}

// singleton
export default new StepperFlow();
